import { parse, format } from 'date-fns'

export function getClassName(item){
    return item.props.className ? "-"+item.props.className : "";
}

export function language(){
    return window.location.search.split('id=')[1]
}

export function translate(text){
    const tranlates = require("../translates.json") ? require("../translates.json") : null;
    const lang      = getCurrentLanguage();


    switch(lang){
        case "ca":
            return tranlates[lang][text] || text;
        case "es":
            return tranlates[lang][text] || text;
        case "en":
            return tranlates[lang][text] || text;
        default:
            return text;
    }
}

export function getCurrentLocationByLanguage(lang){
    return "/"+window.location.pathname;
}

export function getCurrentLanguage(){
    const lang = window.location.pathname.split('/')[2];
    let validLang = false;
    getLanguages().map(
        res => res === lang ? validLang = true : false
    );
    if(validLang) return lang;
    return getLanguages()[0];
}

export function getLanguages(){
    return ['ca', 'es', 'en'];
}

export function getApiCurrentLanguage(){
    switch(getCurrentLanguage()){
        case 'ca': return 'cat';
        case 'es': return 'spa';
        case 'en': return 'eng';
        default: return 'spa';
    }
}

export function getLanguageName(lang){
    switch(lang){
        case 'ca': return 'Català';
        case 'es': return 'Español';
        case 'en': return 'English';
        default: return 'Català';
    }
}

export function getLanguageShortName(lang){
    switch(lang){
        case 'ca': return 'Cat';
        case 'es': return 'Cast';
        case 'en': return 'Eng';
        default: return 'Cat';
    }
}

export function languageRoute(lang, route = ''){
    if(lang) return window.location.host+"/"+lang//window.location.host+'/'+lang+route.replace('/'+getCurrentLanguage(), '');
    return window.location.host+route;
}

export function getPath(){
    const location = window.location;
    let path = location.pathname+location.search+location.hash;
    return path.replace(languageRoute(''), '');
}

export function isValidLanguage(){
    const lang = window.location.pathname.split('/')[1];
    let validLang = false;
    getLanguages().map(
        res => res === lang ? validLang = true : null
    );
    return validLang;
}

export function getUrlByLanguage(url){
    if(url.split('/')[1] === getCurrentLanguage()){
        return url;
    }
    return "/"+getCurrentLanguage()+url;
}

export function getPosterframe(video_url){
    let posterframe_url = video_url
	posterframe_url = posterframe_url.replace(/\/404\//g, '/posterframe/')
    posterframe_url = posterframe_url.replace(/\/720\//g, '/posterframe/')
	posterframe_url = posterframe_url.replace(/\.mp4/g, '.jpg')

    const ar_parts = posterframe_url.split("?")
        if (typeof ar_parts[0]!=="undefined") {
            posterframe_url = ar_parts[0]
        }

    return posterframe_url;
}

export function formatDate(date) {
    var string = date.split(" ");
    if (string[0].match(/00-00$/)) {
        string = string[0].split('-');
        return (string[0]);
    }
    return format(parse(string[0], 'yyyy-MM-dd', new Date()), 'dd/MM/yyyy');
}


export function informantNameDisplay(informant) {
    if (informant.name !== null && informant.surname !== null) {
        return informant.surname+', '+informant.name;
    }
    if (informant.surname !== null) {
        return informant.surname;
    }
    if (informant.name !== null) {
        return informant.name;
    }
    return '';
}
export function informantNameDisplayWidthBr(informant) {
    if (informant.name !== null && informant.surname !== null) {
        return <>{informant.surname},<br/>{informant.name}</>;
    }
    if (informant.surname !== null) {
        return informant.surname;
    }
    if (informant.name !== null) {
        return informant.name;
    }
    return '';
}


export function fragmentsSort(items) {
    return items.sort((a, b) => {
        return informantNameDisplay(a[1].informant[0]).localeCompare(informantNameDisplay(b[1].informant[0]))
    });
}

export function menuEntrys() {
    return [
        'acompanyant',
        'empatitzant',
        'ensenyant',
        'reconfortant',
        'escoltant',
        'respectant',
        'ajudant',
    ];
};

export function classConvert(group) {
    const convert = {
        'acompanyant': 'has-background-acompanyant',
        'empatitzant': 'has-background-empatitzant',
        'ensenyant': 'has-background-ensenyant',
        'reconfortant': 'has-background-reconfortant',
        'escoltant': 'has-background-escoltant',
        'respectant': 'has-background-respectant',
        'ajudant': 'has-background-ajudant',
    }
    if (typeof convert[group] === 'undefined') {
        return group;
    }
    return convert[group];
};

export function titleConvert(group) {

    const convert = {
        'acompanyant': translate('Acompanyant'),
        'empatitzant': translate('Empatitzant'),
        'ensenyant': translate('Ensenyant'),
        'reconfortant': translate('Reconfortant'),
        'escoltant': translate('Escoltant'),
        'respectant': translate('Respectant'),
        'ajudant': translate('Ajudant'),
    }
    if (typeof convert[group] === 'undefined') {
        return group;
    }
    return convert[group];
};

export function colorConvert(group) {

    const convert = {
        'acompanyant': '#a3c6ff',
        'empatitzant': '#fff9a3',
        'ensenyant': '#ffa3c8',
        'reconfortant': '#a6ffa3',
        'escoltant': '#c5a3ff',
        'respectant': '#ffbaa3',
        'ajudant': '#a3fff4',
    }
    if (typeof convert[group] === 'undefined') {
        return '#000';
    }
    return convert[group];
};

export function convertVideoResolution(url) {
    return url.replace("/404/", "/720/");
    //return url;
}

export function videoPositionClass(interview) {
    const leftVideos = [
        24, 68, 11, 67, //acompanyant
        28, 39, 65, 51, 56, 27, 31, //empatitzant
        7, 74, //ensenyant
        76, 61, 69, //reconfortant
        71, 29, 8, 57,  //escoltant
        66,  //respectant
        17, 55, 5, 15 //ajudant
    ];
    if (leftVideos.includes(interview.section_id)) {
        return 'info-box-left';
    }
    return '';
}